export default "__VITE_ASSET__da4aa7b8__"